export const LAST_LANDING_PREFERENCE_KEY = "lastLandingSurface"
export const LAST_LANDING_PREFERENCE_TYPE = "accountNavigation"

export const SURFACE_TYPES = {
  DASHBOARD: "dashboard",
  PORTFOLIO: "portfolio",
}

function parseStoredJson(raw) {
  if (raw == null || raw === "") {
    return null
  }
  try {
    return JSON.parse(raw)
  } catch {
    return null
  }
}

function getLandingFromSurfaceValue(accountAlias, surface) {
  if (!surface || typeof surface !== "object") {
    return null
  }
  if (surface.type === SURFACE_TYPES.DASHBOARD) {
    return { url: `/${accountAlias}/dashboard`, portfolioIdToSelect: null }
  }
  if (surface.type === SURFACE_TYPES.PORTFOLIO && surface.portfolioId) {
    const { portfolioId } = surface
    return { url: `/${accountAlias}/p/${portfolioId}`, portfolioIdToSelect: portfolioId }
  }
  return null
}

export function resolveAccountRootLanding({
  accountAlias,
  preferenceValue,
  storage = window?.localStorage ?? null,
}) {
  const getItem = (key) => (storage ? storage.getItem(key) : null)

  const fromPreference = getLandingFromSurfaceValue(accountAlias, preferenceValue)
  if (fromPreference) {
    return fromPreference
  }

  const legacyLastAccessed = getItem(`OP_${accountAlias}_LastAccessed`)
  if (legacyLastAccessed === "dashboard") {
    return { url: `/${accountAlias}/dashboard`, portfolioIdToSelect: null }
  }

  const lastPortfolios = parseStoredJson(getItem(`OP_${accountAlias}_LastPortfolios`))
  if (lastPortfolios && lastPortfolios.length) {
    const id = lastPortfolios[0].shortId || lastPortfolios[0].id
    return { url: `/${accountAlias}/p/${id}`, portfolioIdToSelect: id }
  }

  return { url: `/${accountAlias}/home`, portfolioIdToSelect: null }
}
